import { render, staticRenderFns } from "./CollaboratorActions.vue?vue&type=template&id=4c8136f9&scoped=true&"
import script from "./CollaboratorActions.vue?vue&type=script&lang=js&"
export * from "./CollaboratorActions.vue?vue&type=script&lang=js&"
import style0 from "./CollaboratorActions.vue?vue&type=style&index=0&id=4c8136f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8136f9",
  null
  
)

export default component.exports